export function getDefaultPrefixName() {
    return null; // no prefix now!  //return 'ace';
}
export function getDefaultPrefix() {
    const n = getDefaultPrefixName();
    return n ? `${n}-` : null;
}
export function allWithPrefix(prefix, classNames) {
    const newClassNames = Object.assign({}, classNames);
    for (const k in newClassNames) {
        newClassNames[k] = withPrefix(prefix, newClassNames[k]);
    }
    return newClassNames;
}
export function withPrefix(prefix, className) {
    return prefix == null || className.startsWith(prefix) ? className : prefix + className;
}
//# sourceMappingURL=withPrefix.js.map
